var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_has.js
// module id = ./node_modules/core-js/modules/_has.js
// module chunks = polyfills